module.exports = __webpack_public_path__ + "static/img/slider1.84e71ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider1.png
// module id = Kjci
// module chunks = 1